<template>
  <div class="decoration-perview">
    <img
      class="decoration-perview-top"
      :src="require('./images/iframe-top.png')"
    >
    <div
      class="decoration-perview-name"
    >
      {{ name }}
    </div>
    <iframe
      ref="iframe"
      frameBorder="0"
      allowFullScreen="true"
      class="decoration-perview-iframe"
      :src="previewUrl"
    >
    </iframe>
  </div>
</template>

<script>
import Messager from '../../helper/messager.js'
export default {
  name: 'DecorationPreview',
  props: {
    name: {
      type: String,
      default: '名片'
    }
  },
  data () {
    return {
      messager: null
    }
  },
  computed: {
    previewUrl () {
      const sessionId = JSON.parse(window.localStorage.getItem('user')).sid
      const host = window.location.host
      return `${this.$env.VUE_APP_WXMINI_CONFIG_BASE_URL}/wxmini-config/index.html#/pages/person-web-config/index?sessionId=${sessionId}&host=${host}`
    }
  },
  mounted () {
    this.initMessager()
  },
  methods: {
    initMessager () {
      const messager = new Messager(this.$refs.iframe.contentWindow, this.$env.VUE_APP_WXMINI_CONFIG_BASE_URL)
      this.messager = messager
    },
    handleOnChange (data) {
      this.messager.emit('onChange', { test: 'data' })
    }
  }
}
</script>

<style lang="scss" scoped>
.decoration-perview {
  position: relative;
  margin-left: 50px;
  margin-top: 20px;
  width: 380px;
  background-color: #fff;

  .decoration-perview-top {
    width: 380px;
    height: 64px;
  }

  .decoration-perview-iframe {
    width: 380px;
    height: calc(100vh - 176px);
  }

  .decoration-perview-name {
    position: absolute;
    top: 36px;
    left: 24px;
    font-size: 18px;
  }
}
</style>
